export default {
  pageTitle: 'Store deposit and exemption information',
  titleText: 'Store deposit and exemption information',
  marginAmount: 'Current deposit balance',
  marginAmountTips: 'The balance is too small, please recharge it',
  curMonth: 'Exemption amount of this month',
  initial: 'Beginning',
  deducted: 'Deducted',
  available: 'Available',
  searchLabel: 'View the deposit and exemptions',
  startYears: 'Start month',
  endYears: 'End month',
  columns: {
    month: 'Month',
    exemptionDeduction: 'Exemption deduction',
    marginPenaltyDeduction: 'Deposit penalty',
    unit: 'Unit'
  }
}
